import Vue from 'vue'
import App from './App.vue'
import store from './store/index-store'
import VueResource from 'vue-resource'
import { VueHammer } from 'vue2-hammer'
import * as services from "./components/services/match.service.js"
import axios from 'axios'

Vue.use(VueResource)
Vue.use(VueHammer)

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
    moment
})

import 'es6-promise/auto'

import router from '../src/store/router.js'

//import './registerServiceWorker'

Vue.config.productionTip = false
    // Vue.use(VueRouter)

// if('serviceWorker' in navigator){
//   navigator.serviceWorker.register('./sw.js')
//   .then(function(){
//     console.log("SW registered")
//   });
// }

// let deferredPrompt;

// window.addEventListener('beforeinstallprompt', (e) => {
//   // Prevent Chrome 67 and earlier from automatically showing the prompt
//   e.preventDefault();
//   // Stash the event so it can be triggered later.
//   deferredPrompt = e;
//   // Update UI to notify the user they can add to home screen

//   var addBtn = document.getElementById('btnadd')


//   addBtn.style.display = 'block';

//   addBtn.addEventListener('click', (e) => {
//     // hide our user interface that shows our A2HS button
//     addBtn.style.display = 'none';
//     // Show the prompt
//     deferredPrompt.prompt();
//     // Wait for the user to respond to the prompt
//     deferredPrompt.userChoice.then((choiceResult) => {
//         if (choiceResult.outcome === 'accepted') {
//           console.log('User accepted the A2HS prompt');
//         } else {
//           console.log('User dismissed the A2HS prompt');
//         }
//         deferredPrompt = null;
//       });
//   });
// });


Vue.mixin({
    data: () => ({
        BASE_URL: process.env.VUE_APP_BASE_PATH,
        urlEPCITECDATA: "https://citec.futbol/apigw/v1/CITEC-IAD360/"
    }),
    methods: {
        generalShowPlayer(idPlayer, player) {

            if (player) {
                store.dispatch('CURRENT_PLAYER', player)
            }

            this.$router.push('/player/' + idPlayer)
        },

        generalShowNews(idNoticia) {
            this.$router.push('/detailnews/' + idNoticia)
        },

        generalProcessDataFromURL(poVariable, psNameElement, psPrefix, psPosfix = null, paOnCondition = null, poCallFunction = null) {
            if (typeof poVariable[psNameElement] !== "object") {
                let psNameDOMElement = psPrefix + "_" + psNameElement + "_" + psPosfix
                psNameDOMElement = psNameDOMElement.replace(/\s/g, "_")
                    //console.log(psNameElement + '--' + psNameDOMElement+" = "+poVariable[psNameElement])
                if (document.getElementById(psNameDOMElement) !== null) {
                    if (document.getElementById(psNameDOMElement).tagName !== "IMG") {
                        document.getElementById(psNameDOMElement).innerHTML = poVariable[psNameElement]
                    } else {
                        document.getElementById(psNameDOMElement).src = document.getElementById(psNameDOMElement).src.split("undefined").join(poVariable[psNameElement])
                    }
                }
            } else {
                for (var subVarName in poVariable[psNameElement]) {
                    this.generalProcessDataFromURL(poVariable[psNameElement], subVarName, psPrefix + "_" + psNameElement, psPosfix)
                }
            }
        },


        setDisplayPositionPlayer(idPlayer, functionCallBack) {
            //console.log("Consulta id: "+idPlayer)
            services.loadUltimoPartidoJugador(idPlayer)
                .then(result => {
                    let vnIDPartido = result.data[0].idPartido
                    let posX = null
                    let posY = null
                        //console.log("Jugador: "+idPlayer)
                        //console.log("Ultimo Partido Jugador: "+vnIDPartido)
                    axios
                        .get(this.urlEPCITECDATA + "LIVE-Lineups?ID=" + vnIDPartido)
                        .then(response => {
                            let vbFound = false
                                //*** Buscar en alineaciones iniciales local*/
                            if (typeof response.data.Result.DatosJSON.equipo_local.alineacion_inicial[0].alineacion === "object") {
                                let voAlineaciones = response.data.Result.DatosJSON.equipo_local.alineacion_inicial[0].alineacion
                                for (var numeroJugador in voAlineaciones) {
                                    if (parseInt(voAlineaciones[numeroJugador].ID) == idPlayer) {
                                        posX = voAlineaciones[numeroJugador].X
                                        posY = voAlineaciones[numeroJugador].Y
                                        vbFound = true
                                        break
                                    }
                                }
                            }
                            //*** Buscar en los cambios local */

                            if (typeof response.data.Result.DatosJSON.equipo_local.alineaciones_partido === "object" && !vbFound) {
                                let voAlineacionesPartido = response.data.Result.DatosJSON.equipo_local.alineaciones_partido
                                for (var vnMinuto in voAlineacionesPartido) {
                                    for (var vsNumeroAlineacion in voAlineacionesPartido[vnMinuto]) {
                                        for (var vsNumeroAlineado in voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion) {
                                            if (parseInt(voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion[vsNumeroAlineado].ID) == idPlayer) {
                                                posX = voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion[vsNumeroAlineado].X
                                                posY = voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion[vsNumeroAlineado].Y
                                                vbFound = true
                                                break
                                            }
                                        }
                                    }
                                }
                            }
                            //*** Buscar en alineaciones iniciales Visita*/
                            if (typeof response.data.Result.DatosJSON.equipo_visitante.alineacion_inicial[0].alineacion === "object" && !vbFound) {
                                let voAlineaciones = response.data.Result.DatosJSON.equipo_visitante.alineacion_inicial[0].alineacion
                                for (var numeroJugador in voAlineaciones) {
                                    if (parseInt(voAlineaciones[numeroJugador].ID) == idPlayer) {
                                        posX = voAlineaciones[numeroJugador].X
                                        posY = voAlineaciones[numeroJugador].Y
                                        vbFound = true
                                        break
                                    }
                                }
                            }
                            //*** Buscar en los cambios Visita */
                            if (typeof response.data.Result.DatosJSON.equipo_visitante.alineaciones_partido === "object" && !vbFound) {
                                let voAlineacionesPartido = response.data.Result.DatosJSON.equipo_visitante.alineaciones_partido
                                for (var vnMinuto in voAlineacionesPartido) {
                                    for (var vsNumeroAlineacion in voAlineacionesPartido[vnMinuto]) {
                                        for (var vsNumeroAlineado in voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion) {
                                            if (parseInt(voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion[vsNumeroAlineado].ID) == idPlayer) {
                                                posX = voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion[vsNumeroAlineado].X
                                                posY = voAlineacionesPartido[vnMinuto][vsNumeroAlineacion].alineacion[vsNumeroAlineado].Y
                                                vbFound = true
                                                break
                                            }
                                        }
                                    }
                                }
                            }

                            functionCallBack(posX, posY)

                        })

                })
                .catch(error => {
                    console.log(error)
                })
        }

    }
})


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')